export default (a, b) => (!a && !b ? true : a == b);
